
/**
 * Copyright (c) 20240701, Mohamed eRrais (merrais / MeR) 
 * from tajwyd.akademy.ma
 * logo.png Compressed from digitalservices.ma
 */

import {arConfig} from './ar';

export const cnConfig = {
    ...arConfig.base,
    salaam:'Salaam',

home : {
    ...arConfig.home,
    login:'登录',
    about:'随时随地阅读、学习和记忆《古兰经》的 Moshaf 服务',
    article : '文章',
    contact : '联系',
},

profile : {
    profile : '个人资料',
    audio : 'Audio',
    monitor:'监控',
    akademy : 'Akademy',
    akademyApp : 'AkademyApp',
    setting : '设置',
}
}